export default __webpack_public_path__ + "static/media/OurChanges2.3f75876b.png";